// API base URL - defaults to relative path for local dev, uses env var for production
// Vite replaces import.meta.env.VITE_* at build time
// Using a direct reference that Vite can replace
const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string) || ''

// Log API base URL on first load (helps debug production issues)
if (typeof window !== 'undefined') {
  const rawEnv = import.meta.env.VITE_API_BASE_URL
  console.log('[API Config] Raw import.meta.env.VITE_API_BASE_URL:', rawEnv)
  console.log('[API Config] API_BASE_URL constant:', API_BASE_URL || '(empty - using relative paths)')
  console.log('[API Config] Will call API at:', API_BASE_URL || window.location.origin)
  console.log('[API Config] Type check:', typeof rawEnv, 'Value:', JSON.stringify(rawEnv))
  console.log('[API Config] Full import.meta.env keys:', Object.keys(import.meta.env).filter(k => k.startsWith('VITE_')))
}

export function apiUrl(path: string): string {
  const base = String(API_BASE_URL || '').trim().replace(/\/+$/, '')
  const p = path.startsWith('/') ? path : `/${path}`
  return base ? `${base}${p}` : p
}

export async function apiFetch(path: string, options?: RequestInit): Promise<Response> {
  return fetch(apiUrl(path), options)
}
